<p-fieldset styleClass="mt-2" *ngIf="processingRates">
	<ng-template pTemplate="header">
		<div class="d-flex">
			<fa-icon [icon]="['far', 'badge-percent']"></fa-icon>
			<div class="mx-2">Payment Service Rates</div>
			<div class="ms-auto">
				<fa-icon [icon]="['far', 'question-circle']" (click)="displayModal.emit('rates')"></fa-icon>
			</div>
		</div>
	</ng-template>
	<div class="p-grid">
		<div class="p-col">
			<div class="d-flex justify-content-center">
				<fa-icon [icon]="['fab', 'cc-visa']" size="4x" class="mx-2"></fa-icon>
				<fa-icon [icon]="['fab', 'cc-mastercard']" size="4x" class="mx-2"></fa-icon>
				<fa-icon [icon]="['fab', 'cc-discover']" size="4x" class="mx-2"></fa-icon>
			</div>
			<div class="d-flex justify-content-center mt-3 h4 fc-font-size-xl">
				{{ processingRates.interchangeBinSponsorship }}% /
				{{ processingRates.interchangeTransaction | currency }}
			</div>
			<div class="d-flex justify-content-center h4">per transaction</div>
		</div>
		<div class="p-col justify-content-end align-middle">
			<div class="d-flex justify-content-center">
				<fa-icon [icon]="['fab', 'cc-amex']" size="4x" class="mx-2"></fa-icon>
			</div>
			<div class="d-flex justify-content-center mt-3 h4 fc-font-size-xl">
				{{ processingRates.amexBinSponsorship }}% /
				{{ processingRates.amexTransaction | currency }}
			</div>
			<div class="d-flex justify-content-center h4">per transaction</div>
		</div>
	</div>
	<p-accordion>
		<p-accordionTab header="Other rates & fees">
			<div class="d-flex flex-wrap justify-content-center">
				<ng-container *ngFor="let fee of focuspayRates">
					<div class="m-2 d-flex flex-column">
						<div class="h4 text-center">{{ fee.displayName }}</div>
						<div class="h4 text-center">
							<span *ngIf="fee.rateType === 'percent'">{{ fee.applicationRate || fee.baseRate }}%</span>
							<span *ngIf="fee.rateType !== 'percent'">{{ fee.applicationRate || fee.baseRate | currency }}</span>
							<fa-icon [icon]="['far', 'question-circle']" [pTooltip]="fee.description" class="ms-1"></fa-icon>
						</div>
					</div>
				</ng-container>
			</div>
		</p-accordionTab>
	</p-accordion>
</p-fieldset>
